import {
    FETCH_CAMPAIGNS,
    FETCH_CAMPAIGNS_ACCUMULATED,
    FETCH_CAMPAIGNS_FAILURE,
    FETCH_CAMPAIGNS_SUCCESS,

    FETCH_CAMPAIGN,
    FETCH_CAMPAIGN_ACCUMULATED,
    FETCH_CAMPAIGN_FAILURE,
    FETCH_CAMPAIGN_SUCCESS,
} from 'store/actions/types';
import utils from 'helpers/utils';

export const fetchCampaigns = (payload) => {
    payload = payload || {};

    let params = {
        size: payload.size ? payload.size : 12,
        sort_by: payload.field ? payload.field : 'id',
        sort_direction: payload.order ? payload.order.toLowerCase() : 'asc',
    };

    if (!payload.offset && payload.page) {
        params.offset = (payload.page - 1) * params.size;
    }

    if (!utils.isEmpty(payload.filter)) {
        const filters = utils.buildFilterObject(payload.filter);

        params = Object.assign({}, params, filters);
    }

    return {
        type: FETCH_CAMPAIGNS,
        payload: params,
    };
};

export const fetchCampaignsFailure = (error) => {
    return {
        type: FETCH_CAMPAIGNS_FAILURE,
        error: error,
    };
};

export const fetchCampaignsSuccess = (payload) => {
    return {
        type: FETCH_CAMPAIGNS_SUCCESS,
        payload: payload,
    };
};

export const fetchCampaign = (payload) => {
    return {
        type: FETCH_CAMPAIGN,
        payload: payload,
    };
};

export const fetchCampaignFailure = (error) => {
    return {
        type: FETCH_CAMPAIGN_FAILURE,
        error: error,
    };
};

export const fetchCampaignSuccess = (response) => {
    return {
        type: FETCH_CAMPAIGN_SUCCESS,
        response: response,
    };
};

export const fetchCampaignAccumulated = (payload) => {
    return {
        type: FETCH_CAMPAIGN_ACCUMULATED,
        payload: {
            id: payload.id,
            resource: 'campaigns',
            type: FETCH_CAMPAIGNS_ACCUMULATED,
        },
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/campaigns/fetchCampaigns.js